module.exports = __webpack_public_path__ + "assets/img/avatar_lil_leo.e8ec4771.png";